module.exports = __webpack_public_path__ + "media/packs/images/flags/MG-c52f597c372671f762c66ce304179dc1.svg";